module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/arrow-57d83677e1c75bc8a706b0e0574001cc.svg";